// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type InfoCircle40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle40: FC<InfoCircle40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M20 15.167a1.44 1.44 0 0 0 1.049-.416c.282-.276.423-.62.423-1.029 0-.425-.14-.781-.423-1.069a1.41 1.41 0 0 0-1.049-.43c-.416 0-.766.143-1.049.43a1.465 1.465 0 0 0-.423 1.07c0 .409.14.752.423 1.028.282.277.631.416 1.049.416ZM18.695 28.333h2.777v-10h-2.777v10Z" />
            <path
                d="M35 20c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15Zm-2.5 0c0 6.904-5.596 12.5-12.5 12.5S7.5 26.904 7.5 20 13.096 7.5 20 7.5 32.5 13.096 32.5 20Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default InfoCircle40;
